import { render, staticRenderFns } from "./realEstateDeals.vue?vue&type=template&id=48246d39"
import script from "./realEstateDeals.vue?vue&type=script&lang=js"
export * from "./realEstateDeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports